import { FunctionsHttpError } from '@supabase/supabase-js'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

type JsonResponse = {
  clone: () => {
    json: () => Promise<unknown>
  }
}

function isJsonResponse(value: unknown): value is JsonResponse {
  return isRecord(value) && typeof value.clone === 'function'
}

/**
 * Edge Functions deliberately return safe, action-specific errors in their
 * response body. Preserve those messages instead of replacing them with the
 * generic Supabase transport error shown for every non-2xx response.
 */
export async function readFunctionError(error: unknown, fallback = 'The service request could not be completed.'): Promise<string> {
  if (error instanceof FunctionsHttpError) {
    try {
      const context: unknown = error.context
      const body: unknown = isJsonResponse(context) ? await context.clone().json() : null
      if (isRecord(body) && typeof body.error === 'string' && body.error.trim()) {
        return body.error
      }
    } catch {
      // Use the transport error below when the function did not return JSON.
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message
  }

  return fallback
}
